import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Button } from 'reactstrap';
import { compareVersions } from 'compare-versions';
import {
  useAppContext,
  formatMediumDate,
  callNativeMobileApp,
  useTranslator,
  withMobileAppMode,
} from '@front-activerse/common-components';

const InstacartButton = ({ categories, start, end, mobileApp }) => {
  const { trackFirebaseEvent } = useOutletContext();
  const { t } = useTranslator();
  const [preloadInstacart, setPreloadInstacart] = useState(false);

  const {
    consts: { INSTACART_FIREBASE_FUNCTION, INSTACART_URL },
    images: { instacartLogo },
  } = useAppContext();

  const handleInstaCart = async () => {
    const ingredients = [];

    if (categories.length > 0) {
      categories.forEach((category) => {
        if (category.products.length > 0) {
          category.products.forEach((product) => {
            if (!product.isBought) {
              const measurement = product.measurements[0];

              if (measurement) {
                const measure = `${measurement.amount} ${measurement.text.replace('%s', '')}`;
                ingredients.push(`${measure} ${product.name}`);
              }
            }
          });
        }
      });
    }

    const request = {
      name: 'Shopping list',
      ingredients,
      recipe: [],
      image: '',
      description: `Shopping list for the days: ${formatMediumDate(start)} - ${formatMediumDate(
        end
      )}`,
    };

    setPreloadInstacart(true);

    const response = await fetch(INSTACART_FIREBASE_FUNCTION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    response.json().then((data) => {
      setPreloadInstacart(false);

      if (data.instacartUrl) {
        const recipeData = encodeURIComponent(data.instacartUrl);
        const instacartUrl = `${INSTACART_URL}?recipeSourceUrl=${recipeData}&utm_source=instacart_growth_partnerships&aff_id=1818&offer_id=1&affiliate_platform=recipe_widget`;

        trackFirebaseEvent('user_action', {
          action: 'tap-instacart_button',
          location: 'Shopping_list',
        });

        if (
          mobileApp &&
          mobileApp.os &&
          mobileApp.os.toLowerCase().startsWith('ios') &&
          mobileApp.version &&
          compareVersions(mobileApp.version, '4.0.2')
        ) {
          callNativeMobileApp({
            action: 'deeplink_open',
            payload: {
              url: instacartUrl,
            },
          });
        } else {
          window.location = instacartUrl;
        }
      }
    });
  };
  return (
    <div className="text-center mb-xl">
      <Button
        color="instacart"
        className="w-100"
        onClick={handleInstaCart}
        disabled={preloadInstacart}
      >
        {preloadInstacart && (
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          />
        )}
        {t('orderIngredients.instacart.button')}{' '}
        <img
          src={instacartLogo}
          style={{
            verticalAlign: 'baseline',
            height: '13px',
          }}
          alt="instacart"
        />
      </Button>
    </div>
  );
};

export default withMobileAppMode(InstacartButton);
